export default __webpack_public_path__ + "static/media/mattress.06630544.svg";